import { call, put, all, takeLatest } from "redux-saga/effects";

import { checkoutActions } from "./checkout.reducer";

import { getPublishableKey } from "../../apis/payment.apis";

// Get Stripe PK async
export function* getStripePKAsync() {
  try {
    const stripePK: string = yield call(getPublishableKey);

    yield put(checkoutActions.getStripePKSuccess(stripePK));
  } catch (error) {
    yield put(checkoutActions.getStripePKFailure(error));
  }
}

export function* getStripePKStart() {
  yield takeLatest(checkoutActions.getStripePKStart.type, getStripePKAsync);
}

export function* checkoutSagas() {
  yield all([call(getStripePKStart)]);
}
